import {Injectable} from '@angular/core';
import { FeaturesService } from './features.service';

@Injectable({
  providedIn: 'root'
})
export class MaskService {
  mask = '+00 (000) 000-0000';
  date = '00.00.0000';
  time = '00:00';

  constructor(private featuresService: FeaturesService) {}

  get phoneMask(): string {
    return this.featuresService.getPhoneMask();
  }
}
